/* eslint-disable import/prefer-default-export */
import { RESET_TERMS } from 'Redux/actions/types';

export const resetTermsAndConditions = () => ({
  type: RESET_TERMS,
});
